
function bindSmoothScrollToHash(selector, duration = 600) {
  jQuery(document)
    .off("click.smooth-toc", selector)
    .on("click.smooth-toc", selector, function (event) {
      const href = jQuery(this).attr("href") || "";
      if (!href || href.charAt(0) !== "#") {
        return;
      }

      const target = jQuery(href);
      if (!target.length) {
        return;
      }

      event.preventDefault();
      jQuery("html, body")
        .stop(true)
        .animate({ scrollTop: target.offset().top }, duration);
    });
}

export function tableOfContents(headersSelector = "h2,h3,h4,h5,h6") {
  var headers = jQuery("#page_contents").find(headersSelector);
  if (headers.length <= 2) {
    jQuery("#table_of_contents").css("visibility", "hidden");
    jQuery("#post-navigation").css("visibility", "hidden");
    return false;
  } else {
    jQuery("#table_of_contents").show();
    jQuery("#post-navigation").css("display", "flex");
    var list = jQuery("#table_of_contents ol").empty().attr("data-level", "1");
    var previousTag, nestedList, currentList;
    var currentLevel = 1;

    headers.each((index, element) => {
      if (jQuery(element).text() == "") {
        return;
      }
      var slug = convertToSlug(jQuery(element).text());

      // Edit table of contents
      var currentTag = parseInt(jQuery(element).prop("tagName").substr(1));
      var listElement = jQuery(
        '<li data-tag="' +
        jQuery(element).prop("tagName").toLowerCase() +
        '"><a href="#' +
        slug +
        '">' +
        jQuery(element).text().trim() +
        "</a></li>"
      );

      if (previousTag === undefined) {
        // First item
        currentList = jQuery('ol[data-level="' + currentLevel + '"]');
      } else if (previousTag === currentTag) {
        // Same level
        currentList = jQuery(list.find("li").last()).parent();
      } else if (previousTag > currentTag) {
        // Upper level
        currentLevel = currentTag - 1;
        // console.log('upper ' + currentLevel);
        currentList = jQuery('ol[data-level="' + currentLevel + '"]').last();
      } else if (previousTag < currentTag) {
        // Nested level
        nestedList = jQuery(
          '<ol data-level="' + currentLevel + '"></ul>'
        ).empty();
        ++currentLevel;
        nestedList = jQuery(
          '<ol data-level="' + currentLevel + '"></ul>'
        ).last();
        list.find("li").last().append(nestedList);
        currentList = jQuery('ol[data-level="' + currentLevel + '"]').last();
      }
      currentList.append(listElement);
      previousTag = parseInt(
        jQuery(element).prop("tagName").toLowerCase().substr(1)
      );
    });

    bindSmoothScrollToHash("#table_of_contents a[href^='#']", 600);
  }
}

export function convertToSlug(string) {
  return string
    .normalize("NFD")
    .trim()
    .replace(/ /g, "-")
    .toLowerCase()
    .replace(/[^\w-]+/g, "");
}

/* Wrap link with <a> */
export function add_link_hover(element) {
  var slug = convertToSlug(jQuery(element).text());
  var link =
    jQuery(location).attr("origin") + jQuery(location).attr("pathname");

  jQuery(element).attr("id", slug);
  var copyLink = jQuery("<a>", {
    class: "copy-link",
    title: "Copy link",
    "data-href": link + "#" + slug,
    onclick: "copyToClipboard('" + link + "#" + slug + "')",
  });
  jQuery(element).wrap(copyLink);
}

export function include_copied_text_badge(parent_element) {
  jQuery(parent_element).prepend(
    '<span class="copied" style="/* display: none; */">Copied!</span>'
  );
}